'use client'
import SettingHeader from '../../../components/settings/SettingHeader'

const Page = () => {
    return (
        <div style={{height:'100vh'}}>
            <SettingHeader
                heading="Text"
                para="Text"
                btnTxt="Text"
            />
        </div>
    )
}

export default Page